// extracted by mini-css-extract-plugin
export default {"renderItem":"row-info-indicator_renderItem__zMCg4"};